import { useState } from "react";
import { CELEBRATE_OPTIONS } from "@/lib/calApi";
import { HebrewDateFields, inputClass } from "@/components/calendar/HebrewDateFields";

const Label = ({ children, className = "" }) => <span className={`block text-xs text-cocoa-soft mb-1 ${className}`}>{children}</span>;

export function PersonForm({ initial, branches, onSave, onCancel, busy }) {
  const [p, setP] = useState(initial || { name: "", nickname: "", branch: "", gdate: "", hdate: null, celebrate: "both", status: "", is_pet: false, death_gdate: "", death_hdate: null });
  const set = (k, v) => setP((x) => ({ ...x, [k]: v }));
  const [showDeath, setShowDeath] = useState(!!(p.death_gdate || p.death_hdate));
  const submit = (e) => {
    e.preventDefault();
    onSave({ ...p, gdate: p.gdate || null, death_gdate: p.death_gdate || null,
      hdate: p.hdate?.day ? p.hdate : null, death_hdate: p.death_hdate?.day ? p.death_hdate : null });
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="cal-admin-person-form">
      <div className="grid sm:grid-cols-2 gap-3">
        <label><Label>Nombre completo</Label><input required data-testid="pf-name" value={p.name} onChange={(e) => set("name", e.target.value)} className={inputClass} /></label>
        <label><Label>Apodo (opcional)</Label><input data-testid="pf-nickname" value={p.nickname || ""} onChange={(e) => set("nickname", e.target.value)} className={inputClass} /></label>
      </div>
      <label className="block"><Label>Rama familiar</Label>
        <input list="cal-branches" data-testid="pf-branch" value={p.branch || ""} onChange={(e) => set("branch", e.target.value)} className={inputClass} />
        <datalist id="cal-branches">{branches.map((b) => <option key={b} value={b} />)}</datalist>
      </label>
      <div className="grid sm:grid-cols-2 gap-3">
        <label><Label>Nacimiento (gregoriano)</Label><input type="date" data-testid="pf-gdate" value={p.gdate || ""} onChange={(e) => set("gdate", e.target.value)} className={inputClass} /></label>
        <div><Label>Nacimiento (hebreo)</Label><HebrewDateFields value={p.hdate} onChange={(v) => set("hdate", v)} testId="pf-hdate" /></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <label><Label>Celebrar en</Label>
          <select data-testid="pf-celebrate" value={p.celebrate || "both"} onChange={(e) => set("celebrate", e.target.value)} className={inputClass}>
            {CELEBRATE_OPTIONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </label>
        <label><Label>Estado / nota</Label><input data-testid="pf-status" value={p.status || ""} onChange={(e) => set("status", e.target.value)} placeholder="Por confirmar, Confirmado…" className={inputClass} /></label>
      </div>
      <div className="flex flex-wrap gap-4 text-sm text-cocoa">
        <label className="inline-flex items-center gap-2"><input type="checkbox" data-testid="pf-is-pet" checked={!!p.is_pet} onChange={(e) => set("is_pet", e.target.checked)} /> Es mascota</label>
        <label className="inline-flex items-center gap-2"><input type="checkbox" data-testid="pf-show-death" checked={showDeath} onChange={(e) => setShowDeath(e.target.checked)} /> Falleció (iortzait)</label>
      </div>
      {showDeath && (
        <div className="grid sm:grid-cols-2 gap-3 rounded-2xl bg-night/5 p-3">
          <label><Label>Fallecimiento (gregoriano)</Label><input type="date" data-testid="pf-death-gdate" value={p.death_gdate || ""} onChange={(e) => set("death_gdate", e.target.value)} className={inputClass} /></label>
          <div><Label>Fallecimiento (hebreo)</Label><HebrewDateFields value={p.death_hdate} onChange={(v) => set("death_hdate", v)} testId="pf-death-hdate" /></div>
        </div>
      )}
      <div className="flex gap-2 pt-2">
        <button data-testid="pf-save" disabled={busy} className="rounded-full bg-night text-white px-5 py-2.5 text-sm font-semibold cal-press disabled:opacity-50">Guardar</button>
        <button type="button" data-testid="pf-cancel" onClick={onCancel} className="rounded-full border border-line px-5 py-2.5 text-sm text-cocoa">Cancelar</button>
      </div>
    </form>
  );
}
